/**
 * Image selection coordination module
 * Provides a centralized way to select images and sync them across dealer/customer
 * Works in both standalone and integrated (runtime) modes
 */

type SendSyncFn = (data: { currentImageIndex: number }) => void;
type ScrollToFn = (index: number, instant: boolean) => void;

interface IImageSelectionRegistry {
  sendSync: SendSyncFn | null;
  scrollTo: ScrollToFn | null;
}

const registry: IImageSelectionRegistry = {
  sendSync: null,
  scrollTo: null,
};

/**
 * Register the image selection handlers (called by Micro2DApp component)
 * This allows selectImage to work regardless of whether runtime is loaded
 */
export function registerImageSelection(sendSync: SendSyncFn, scrollTo: ScrollToFn): void {
  registry.sendSync = sendSync;
  registry.scrollTo = scrollTo;
}

/**
 * Unregister handlers when component unmounts
 */
export function unregisterImageSelection(): void {
  registry.sendSync = null;
  registry.scrollTo = null;
}

/**
 * Select a specific image by index and sync to customer
 * Can be called from runtime or any other code
 * @param index - Zero-based image index
 */
export function selectImage(index: number): void {
  if (registry.sendSync) {
    registry.sendSync({ currentImageIndex: index });
  }
  if (registry.scrollTo) {
    registry.scrollTo(index, true);
  }
}
